import { Link } from 'react-router-dom';
import {
  GUEST_TRIAL_ENDED_SIGNUP_PATH,
  GUEST_TRIAL_ENDED_TITLE,
  useIsGuestAccount,
} from '../guest-trial-cta';

const LINK_CLASS =
  'underline font-medium text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100';

/**
 * Inline error rendering for the "user is out of credits" case in chat-based
 * arches. Surfaces a clickable link via react-router so we don't lose SPA
 * state with a hard reload.
 *
 * A guest-trial account cannot buy credits — its trial is a one-time grant —
 * so for a guest the link is "Create a free account" (sign-up keeps everything
 * the guest made) instead of "Buy more credits".
 *
 * Customer Support has its own variant that adds a "create a support ticket"
 * link alongside this one — see SupportHomePage. Other arches that just need
 * the standard prompt should use this component.
 */
export function InsufficientCreditsMessage() {
  const isGuest = useIsGuestAccount();
  if (isGuest) {
    return (
      <span>
        {GUEST_TRIAL_ENDED_TITLE}.{' '}
        <Link to={GUEST_TRIAL_ENDED_SIGNUP_PATH} className={LINK_CLASS}>
          Create a free account
        </Link>{' '}
        to keep going — everything you made stays yours.
      </span>
    );
  }
  return (
    <span>
      Your credit balance is too low for this action.{' '}
      <Link to="/credits" className={LINK_CLASS}>
        Buy more credits
      </Link>{' '}
      to continue using Fias AI.
    </span>
  );
}
